import searchAtomPair from 'atoms/search-atom';
import { DocumentFacets } from 'components/search/common/types';
import { DocumentResponse } from 'types/api-responses';
import { DocumentSearchParams } from './types';
import { atomWithStorage } from 'jotai/utils';
import { SortField } from 'components/documents-search/sort-fields';
import { atom } from 'jotai';

const { searchAtom, resetSearchDataAtom } = searchAtomPair<
  DocumentResponse,
  DocumentSearchParams,
  DocumentFacets
>('documents');

const documentSearchDateSortSettingAtom = atomWithStorage<
  | {
      sortDirection: SortField['direction'];
      sortAttribute: SortField['id'];
    }
  | undefined
>('document-search-date-sort-setting', undefined, undefined, {
  getOnInit: true,
});

interface DateRange {
  start: string;
  end: string;
}

export const documentDateRangeAtom = atom<DateRange | undefined>(undefined);

// Derived atom that formats the dates for display in the date picker
export const formattedDateRangeAtom = atom(
  (get) => {
    const dateRange = get(documentDateRangeAtom);
    if (!dateRange) return undefined;

    return {
      start: dateRange.start ? dateRange.start.split('T')[0] : undefined,
      end: dateRange.end ? dateRange.end.split('T')[0] : undefined,
    };
  },
  (_get, set, newDateRange: DateRange | undefined) => {
    set(documentDateRangeAtom, newDateRange);
  }
);

export { documentSearchDateSortSettingAtom, resetSearchDataAtom, searchAtom };
